import { usersCollection } from '../../config/firebase';

let state = {
	socialLinks: [],
	loading: false,
	notification: { message: '', type: '' },
};
let getters = {
	socialLinks: state => state.socialLinks,
	socialLinkLoading: state => state.loading,
	socialLinkNotification: state => state.notification,
};
let actions = {
	async getSocialLinks({ commit }, payload) {
		
		commit('setSocialLinkLoading', true);
		usersCollection
			.doc(payload)
			.onSnapshot(async snapshot => {
				let { social_links } = snapshot.data();
				
				social_links = social_links ? social_links : [];
				commit('setSocialLinksData', social_links);
				commit('setSocialLinkLoading', false);
			});
	},
	async addSocialLink({ commit }, payload) {
		commit('setSocialLinkLoading', true);
		let id = payload.id;
		delete payload.id;
		try {
			usersCollection
				.doc(id)
				.get()
				.then(async snapshot => {
					let data = snapshot.data();
					let { social_links } = data;
					social_links = social_links ? social_links : [];

					social_links.push({ ...payload });
					data['social_links'] = social_links;
					await usersCollection.doc(id).update({ ...data });
				});
			commit('setSocialLinksNotification', {
				message: 'Social Link Added',
				type: 'success',
			});
		} catch (err) {
			
			commit('setSocialLinksNotification', {
				message: err.message,
				type: 'error',
			});
		} finally {
			commit('setSocialLinkLoading', false);
		}
	},
	async editSocialLink({ commit }, payload) {
		commit('setSocialLinkLoading', true);
		let id = payload.id;
		delete payload.id;
		try {
			usersCollection
				.doc(id)
				.get()
				.then(async snapshot => {
					let {idx} = payload;
					delete payload.idx;
					let data = snapshot.data();
					let { social_links } = data;
					social_links[idx] = { ...payload };
					data['social_links'] = social_links;
					await usersCollection.doc(id).update({ ...data });
				});
			commit('setSocialLinksNotification', {
				message: 'Social Link Updated',
				type: 'success',
			});
		} catch (err) {
			
			commit('setSocialLinksNotification', {
				message: err.message,
				type: 'error',
			});
		} finally {
			commit('setSocialLinkLoading', false);
		}
	},
	async deleteSocialLink({ commit }, payload) {
		commit('setSocialLinkLoading', true);
		let id = payload.id;
		delete payload.id;
		try {
			usersCollection
				.doc(id)
				.get()
				.then(async snapshot => {
					let idx = payload.idx;
					delete payload.idx;
					let data = snapshot.data();
					let { social_links } = data;
					social_links = social_links.filter(
						(social_link, index) => idx != index
					);
					data['social_links'] = social_links;
					await usersCollection.doc(id).update({ ...data });
				});
			commit('setSocialLinksNotification', {
				message: 'Social Link Deleted',
				type: 'success',
			});
		} catch (err) {
			
			commit('setSocialLinksNotification', {
				message: err.message,
				type: 'error',
			});
		} finally {
			commit('setSocialLinkLoading', false);
		}
	},
};
let mutations = {
	setSocialLinksData(state, payload) {
		state.socialLinks = payload;
	},
	setSocialLinkLoading(state, payload) {
		state.loading = payload;
	},
	setSocialLinksNotification(state, payload) {
		let { notification } = state;
		notification.message = payload.message;
		notification.type = payload.type;
		state.notification = notification;
		window.setTimeout(() => {
			let obj = { message: '', type: '' };
			state.notification = obj;
		}, 5000);
	},
};
export default { state, getters, actions, mutations };
